/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-14 10:50:41
 */

import { API_PREFIX } from './constant'
import { Request } from './request'


// 列表
export interface UnqualifiedMedicinesLedgerListParams {
  startTime?: any
  endTime?: any
  current?: any
  size?: any
}

export function getUnqualifiedMedicinesLedgerList(
  params: UnqualifiedMedicinesLedgerListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/`,
    method: 'GET',
    params,
  }
}

// 详情
export function getUnqualifiedMedicinesLedgerDetail(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/`,
    method: 'GET',
    params: {
      id,
    },
  }
}

// 导出
export function getUnqualifiedMedicinesLedgerExport(
  params: UnqualifiedMedicinesLedgerListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/`,
    method: 'POST',
    responseType: 'blob',
    params
  }
}




